import { render, staticRenderFns } from "./Designs.vue?vue&type=template&id=634fd595&scoped=true&"
import script from "./Designs.vue?vue&type=script&lang=js&"
export * from "./Designs.vue?vue&type=script&lang=js&"
import style0 from "./Designs.vue?vue&type=style&index=0&id=634fd595&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634fd595",
  null
  
)

export default component.exports